export const MOBILE_BREAKPOINTS: string[] = ['xs', 'sm'];
